import React, { useState } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal } from "../../../../util";
import { Link } from "react-router-dom";
import DragAndDropTable from "../../../common/DragAndDropTable";
import { formatDatetime } from "../../../../util";

export default function LogoListingPage(props) {
  const { disabled, match } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getLogos = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getLogos(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      console.log(result);
      setRows(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if (pageSize) getLogos();
  }, [getLogos]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete File",
      text: "Are you sure to delete this event?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteLogoById(id);
        toast.dark("The event is deleted.");
        await getLogos();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const saveOrdering = async () => {
    try {
      const seqData = {};
      rows.forEach((e, i) => {
        seqData[e.id] = i + 1;
      });
      const result = await apiHelper.hkiff.orderLogos(seqData);
      if (result.data.code === 0) {
        toast.dark("Your changes is saved.");
        await getLogos();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Group Name (English)",
        accessor: "logoGroupName",
      },
      {
        Header: "Title",
        accessor: "titleEn",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.titleEn}
            </Link>
          );
        },
      },
      {
        Header: "Logo",
        accessor: "image",
        Cell: ({ row }) => {
          return (
            <img
              src={
                row.original.localizations &&
                row.original.localizations.logoUrl
              }
              style={{width: "30px"}}
              alt=""
              height="25px"
            />
          );
        },
      },
      {
        Header: "Last Update",
        accessor: "updateTime",
        disableSortBy: true,
        disableGlobalFilter: true,
        Cell: ({ row }) => {
          return row.original.updateTime
            ? formatDatetime(row.original.updateTime)
            : "-";
        },
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Using Our Logo &gt; Logo
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getLogos}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={(ids) => Promise.all(ids.map((id) => apiHelper.hkiff.deleteLogoById(id)))}
            subject="event"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={handleDelete}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
            addBtnLink={`${props.match.url}/new`}
            addBtnName="Add New Logo"
          />
        </Grid>
      </Grid>
    </>
  );
}
